import IComponent from "components/commons/IComponent";
import "./DetailPanels.scoped.css";
import SingleValueTable from "components/SearchResult/DetailPanels/TableModules/SingleValueTable";
import { dataProcessFunctions } from "./dataProcessFunctions";

import moment from "moment/moment";
import Button from "@material-ui/core/Button";
import PrintSlopeReport from "utils/PrintSlopeReport";

class BasicInfo extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      isBoulderResult: false,
      basicInfo: [
        {
          alias: "Feature Ref. No.",
          field: "FEATURE",
          otherField: "SLOPE_NO",
          value: "",
        },
        {
          alias: "Location",
          field: "LOCATION",
          value: "",
        },
        {
          alias: "First Registration Date",
          field: "REG_DATE",
          type: "date",
          value: "",
        },
        {
          alias: "Ranking Score (NPRS)",
          field: ["NPRS", "NPRS_SOURCE"],
          value: "",
        },
        {
          alias: "Date of Formation",
          field: "YEAR_FORM",
          value: "",
        },
        {
          alias: "Date of Construction/Modification",
          field: "DATE_CON",
          value: "",
        },
        {
          alias: "Data Source",
          field: "DATA_SOURCE",
          value: "",
        },
        {
          alias: "Approximate Coordinates",
          field: "COORDINATES",
          value: "",
        },
      ],
      conseqCat: [
        {
          alias: "Facility at Crest",
          field: "CREST_TYPE",
          value: "",
        },
        {
          alias: "Distance of Facility from Crest (m)",
          field: "CREST_DIST",
          value: "",
        },
        {
          alias: "Facility at Toe",
          field: "TOE_TYPE",
          value: "",
        },
        {
          alias: "Distance of Facility from Toe (m)",
          field: "TOE_DIST",
          value: "",
        },
        {
          alias: "Consequence-to-life Category",
          field: "CONSEQ_CAT",
          value: "",
          isHide: true,
        },
        {
          alias: "Remarks",
          field: "REMARK",
          value: "",
        },
      ],
      slopePart: [
        {
          alias: "Slope Part",
          field: "SlopeParts",
          value: "",
          tableSpec: [
            {
              alias: "No.",
              field: "Order",
              value: [],
            },
            {
              alias: "Max. Height (m)",
              field: "SF_HEIGHT",
              value: [],
            },
            {
              alias: "Length (m)",
              field: "SF_LENGTH",
              value: [],
            },
            {
              alias: "Average Angle (degree)",
              field: "SF_ANGLE",
              value: [],
            },
          ],
        },
      ],
      wallPart: [
        {
          alias: "Wall Part",
          field: "WallParts",
          value: "",
          tableSpec: [
            {
              alias: "No.",
              field: "Order",
              value: [],
            },
            {
              alias: "Max. Height (m)",
              field: "WF_HEIGHT",
              value: [],
            },
            {
              alias: "Length (m)",
              field: "WF_LENGTH",
              value: [],
            },
            {
              alias: "Face Angle (degree)",
              field: "WF_ANGLE",
              value: [],
            },
          ],
        },
      ],
      maintenance: [
        {
          alias: "Mainenance",
          field: "",
          value: [],
          tableSpec: [
            {
              alias: "Sub Div.",
              field: "SUB_DIV_NO",
              value: [],
            },
            {
              alias: "Maintenance Type",
              field: "SMR_CAT_CD",
              value: [],
            },
            {
              alias: "Party",
              field: "RESP_PTY",
              value: [],
            },
            {
              alias: "Agent",
              field: "MAINT_AGENT",
              otherField: "MAINT_AGEN",
              value: [],
            },
            {
              alias: "Land Category",
              field: "LAND_CAT_CD",
              value: [],
            },
            {
              alias: "Reason Code",
              field: "REASON_CD",
              value: [],
            },
            {
              alias: "Date",
              field: "ENDO_DATE",
              value: [],
            },
            {
              alias: "Remarks",
              field: "STD_REMARK", //["STD_REMARK_2", "STD_REMARK_1"],
              value: [],
            },
          ],
        },
      ],

      basicInfo_Boulder: [
        {
          alias: "Feature Ref. No.",
          field: "FEATURE_KEY",
          value: "",
        },
        {
          alias: "Location",
          field: "LOCATION",
          value: "",
        },
        {
          alias: "Approximate Coordinates",
          field: "COORDINATES",
          value: "",
        },
        {
          alias: "Facilities intended to be protected",
          field: "PROTECT_FACI",
          value: "",
        },
        {
          alias: "Purpose of the Mitigation Measures",
          field: "PUR_OF_MEA",
          value: "",
        },
      ],
      stabilisationMeasure: [
        {
          alias: "Boulder Buttress",
          field: "BOULD_BUTT_NUM",
          value: "",
        },
        {
          alias: "Soil Nails",
          field: "SOIL_NAIL_NUM",
          value: "",
        },
        {
          alias: "",
          field: "SOIL_NAIL_LEN",
          value: "",
        },
        {
          alias: "Raking Drains",
          field: "RAK_DRAINS_NUM",
          value: "",
        },
        {
          alias: "",
          field: "RAK_DRAINS_LEN",
          value: "",
        },
        {
          alias: "Ohters",
          field: "OTHERS1_REMARK",
          value: "",
        },
      ],
      defenceMeasure: [
        {
          alias: "Types of Measures",
          field: "MEASURETYPE",
          value: "",
        },
        {
          alias: "Length(m) (for earth bunds and boulder fence only)",
          field: "EARTH_BOULD_LEN",
          value: "",
        },
        {
          alias: "Max. Height (m)",
          field: "MAX_HEIGHT",
          value: "",
        },
        {
          alias: "Others/Remarks",
          field: "OTHERS2_REMARK",
          value: "",
        },
      ],
      // maintenanceResults: []
      mSlopePlan: "",
    };
  }
  async componentDidMount() {
    console.log("basic info did mount");
    this.props.isShowTabCallback(true);

    let isBoulderResult = false;
    let dataProcessClassObj = new dataProcessFunctions();

    if (this.props.text !== "") {
      var finalBoulderResult = this.props.attributes.Boulder;
      if (finalBoulderResult) {
        if (
          finalBoulderResult.FEATURE_KEY &&
          finalBoulderResult.FEATURE_KEY != "N/A"
        ) {
          isBoulderResult = true;
        }
      }
      console.log("finalBoulderResult", finalBoulderResult);

      var finalSMRISResult = this.props.attributes.SIMARs;
      console.log("finalSMRISResult", finalSMRISResult);
    }

    let tmpBasicInfo = Object.assign([], this.state.basicInfo);
    tmpBasicInfo = dataProcessClassObj.assignCellValuesWithFieldValueConcat(
      tmpBasicInfo,
      this.props.attributes
    );

    let tmpConseqCat = Object.assign([], this.state.conseqCat);
    tmpConseqCat = dataProcessClassObj.assignCellValuesWithSingleFieldValue(
      tmpConseqCat,
      this.props.attributes
    );

    let tmpSlopePart = Object.assign([], this.state.slopePart);
    tmpSlopePart = dataProcessClassObj.assignCellTableValues(
      tmpSlopePart,
      this.props.attributes
    );

    let tmpWallPart = Object.assign([], this.state.wallPart);
    tmpWallPart = dataProcessClassObj.assignCellTableValues(
      tmpWallPart,
      this.props.attributes
    );

    let tmpMaintenance = Object.assign([], this.state.maintenance);
    tmpMaintenance = dataProcessClassObj.assignCellTableValuesWithFieldsSelectByPriority(
      tmpMaintenance,
      finalSMRISResult
    );

    let data = null;
    if (!isBoulderResult) {
      data = {
        basicInfo: tmpBasicInfo,
        conseqCat: tmpConseqCat,
        slopePart: tmpSlopePart,
        wallPart: tmpWallPart,
        maintenance: tmpMaintenance,
      };
    } else {
      let tmpBasicInfo_Boulder = Object.assign(
        [],
        this.state.basicInfo_Boulder
      );
      tmpBasicInfo_Boulder = dataProcessClassObj.assignCellTableValues(
        tmpBasicInfo_Boulder,
        finalBoulderResult
      );

      let tmpStabilisationMeasure = Object.assign(
        [],
        this.state.stabilisationMeasure
      );
      tmpStabilisationMeasure = dataProcessClassObj.assignCellTableValues(
        tmpStabilisationMeasure,
        finalBoulderResult
      );

      let tmpDefenceMeasure = Object.assign([], this.state.defenceMeasure);
      tmpDefenceMeasure = dataProcessClassObj.assignCellTableValues(
        tmpDefenceMeasure,
        finalBoulderResult
      );

      data = {
        isBoulderResult: true,
        basicInfo_Boulder: tmpBasicInfo_Boulder,
        stabilisationMeasure: tmpStabilisationMeasure,
        defenceMeasure: tmpDefenceMeasure,
        maintenance: tmpMaintenance,
      };
    }
    this.setState(data);
  }
  componentWillUnmount() {}

  async print() {
    this.props.showDialog({
      isOpen: true,
      title: "Preparing slope report",
      content: (
        <div>
          <span className="icn_loading" />
          Preparing slope report, please wait...
        </div>
      ),
      onDialogCancel: () => {},
    });
    await PrintSlopeReport(this.props.text, this.props.geometry);
    this.props.showDialog({
      isOpen: false,
    });
  }

  render() {
    return (
      <div>
        <div className="SubPanelTitle">
          <div className="EqualWidthChildren">
            <span>Basic Information</span>
            {false && this.props.mapType == 3 ? (
              ""
            ) : (
              <Button
                className="SearchResultButton"
                title="Print Slope Report"
                onClick={() => {
                  this.print();
                }}
              >
                <span className="icn_2d_printer" />
              </Button>
            )}
            <Button
              className="SearchResultButton"
              title="Link to LandsD's SMRIS"
              onClick={() => {
                let slopeNo = this.props.text.trim().replace(/ /g, "");
                let url =
                  "https://www.slope.landsd.gov.hk/smris/index.jsp?slope-no=" +
                  slopeNo +
                  "&lg=en";
                window.open(url);
              }}
            >
              <span
                className="icn_LandsD"
                style={{ filter: "brightness(1)" }}
              />
            </Button>
            {/* <Button className="SearchResultButton" title="3D">
              <span className="icn_2d_goto3d" />
            </Button> */}
          </div>
        </div>
        <table className="ResultInfoTable">
          <tbody>
            {this.state[
              this.state.isBoulderResult ? "basicInfo_Boulder" : "basicInfo"
            ].map((i, j) => {
              return (
                <tr key={`basicInfo_` + j} className="ResultInfoRow">
                  <td className="ResultInfoRowHead">{i.alias}</td>
                  <td className="ResultInfoRowValue">
                    {i.type === "date" && !isNaN(Number(i.value))
                      ? moment(i.value).format("DD-MM-YYYY")
                      : i.value}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {this.state.isBoulderResult ? (
          <div className="SubPanelTitle">STABILISATION MEASURES</div>
        ) : (
          <div style={{ display: "flex" }}>
            <div className="SubPanelTitle">
              Consequence-To-Life Category{" "}
              <span style={{ color: "red" }}>
                (
                {
                  this.state["conseqCat"].find(
                    (item) => item.field === "CONSEQ_CAT"
                  )?.value
                }
                )
              </span>
            </div>
          </div>
        )}
        <table className="ResultInfoTable">
          <tbody>
            {this.state[
              this.state.isBoulderResult ? "stabilisationMeasure" : "conseqCat"
            ]
              .filter((i) => !i.isHide)
              .map((i, j) => {
                return (
                  <tr key={`conseqCat_` + j} className="ResultInfoRow">
                    <td className="ResultInfoRowHead">{i.alias}</td>
                    <td className="ResultInfoRowValue">{i.value}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {!this.state.isBoulderResult ? (
          <div className="SubPanelTitle">Slope Part</div>
        ) : (
          ""
        )}
        {!this.state.isBoulderResult ? (
          <SingleValueTable data={this.state.slopePart} />
        ) : (
          ""
        )}
        {!this.state.isBoulderResult ? (
          <div className="SubPanelTitle">Wall Part</div>
        ) : (
          ""
        )}
        {!this.state.isBoulderResult ? (
          <SingleValueTable data={this.state.wallPart} />
        ) : (
          ""
        )}
        {this.state.isBoulderResult ? (
          <div className="SubPanelTitle">DEFENCE MEASURES</div>
        ) : (
          ""
        )}
        {this.state.isBoulderResult ? (
          <table className="ResultInfoTable">
            <tbody>
              {this.state.defenceMeasure.map((i, j) => {
                return (
                  <tr key={`conseqCat_` + j} className="ResultInfoRow">
                    <td className="ResultInfoRowHead">{i.alias}</td>
                    <td className="ResultInfoRowValue">{i.value}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          ""
        )}
        <div className="SubPanelTitle">
          <div className="EqualWidthChildren">
            <div>Maintenance Responsibility</div>
            <div className="AlignRight">
              <a
                href="/GInfoMap/resources/SMRIS Land Category.pdf"
                target="_blank"
              >
                Land Category
              </a>
              {" | "}
              <a
                href="/GInfoMap/resources/SMRIS Reason Codes.pdf"
                target="_blank"
              >
                Reason Code
              </a>
            </div>
          </div>
        </div>
        <SingleValueTable data={this.state.maintenance} />
      </div>
    );
  }
}

export default BasicInfo;
